import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { useRef, useState, useEffect, memo } from "react";

const EllipsisTooltip = ({ children, className = "",
  tooltipClassName, tooltipWidth, delayDuration = 200,
  skipDelayDuration = 0, title, // ✅ allow custom tooltip content,
  ...props }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const isTextChild = typeof children === "string" || typeof children === "number";
  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, [children]);
  const showTooltip = Boolean(title) || (isTextChild);

  return (
    <TooltipProvider delayDuration={delayDuration} skipDelayDuration={skipDelayDuration} disableHoverableContent={!isOverflowed}>
      <Tooltip>
        <TooltipTrigger asChild>
          <p
            ref={textRef}
            className={cn(
              `block max-w-full whitespace-nowrap overflow-hidden font-sans ${isOverflowed && 'text-ellipsis'}`,
              className
            )}
            style={{ ...props?.style, ...props?.sx }}
            {...props}
          >
            {children}
          </p>
        </TooltipTrigger>
        {showTooltip && (
          <TooltipContent
            containerRef={props.containerRef}
            className={cn("bg-muted-foreground rounded-[5px]" , tooltipWidth ? "" : "max-w-[300px]", tooltipClassName)}
          >
            <span>{title}</span>
          </TooltipContent>
        )}
        {isOverflowed && <TooltipContent containerRef={props.containerRef} className={cn("bg-muted-foreground rounded-[5px]  max-w-[300px]", tooltipClassName)}> {typeof children === "string" || typeof children === "number" ? children : children.props.children}</TooltipContent>}
      </Tooltip>
    </TooltipProvider>
  );
};

export default memo(EllipsisTooltip);

